// extracted by mini-css-extract-plugin
export default {"favorite-messages":"Favorites_favorite-messages__dci7l"};